import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=72f06950&scoped=true"
import script from "./MessageNotice.vue?vue&type=script&lang=js"
export * from "./MessageNotice.vue?vue&type=script&lang=js"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=72f06950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f06950",
  null
  
)

export default component.exports